/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreeTrial
 */
export interface FreeTrial {
    /**
     * 無料トライアル適用済みか
     * @type {boolean}
     * @memberof FreeTrial
     */
    isAppliedFreeTrial: boolean;
    /**
     * 無料トライアル適用済みのクリップID。無料トライアル済みではない場合はnull。
     * @type {number}
     * @memberof FreeTrial
     */
    clipId: number | null;
}

export function FreeTrialFromJSON(json: any): FreeTrial {
    return FreeTrialFromJSONTyped(json, false);
}

export function FreeTrialFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeTrial {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAppliedFreeTrial': json['is_applied_free_trial'],
        'clipId': json['clip_id'],
    };
}

export function FreeTrialToJSON(value?: FreeTrial | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_applied_free_trial': value.isAppliedFreeTrial,
        'clip_id': value.clipId,
    };
}

